import * as React from 'react';

function KamDeleteIcon(props) {
  return (
    <svg
      height={23.3}
      style={{ display: 'block' }}
      viewBox="0 0 26.574 23.3"
      width={26.574}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g data-name="Group 2103">
        <g data-name="Group 2102" fill="none">
          <g data-name="Group 2101" stroke="#202124" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
            <path
              d="M21.65 22.651a19.9 19.9 0 00-2.282-7.572 6.832 6.832 0 00-2.276-2.328c-2.277-1.424-9.664-1.244-11.888 0a7.833 7.833 0 00-3.246 4.406A31.693 31.693 0 00.65 22.651zM15.282 4.734A4.1 4.1 0 1111.184.651a4.091 4.091 0 014.098 4.083z"
              data-name="Path 218"
            />
            <path d="M6.972 22.65v-5.785" data-name="Line 231" />
            <path d="M15.283 22.65v-5.785" data-name="Line 232" />
          </g>
          <path d="M18.15 1.15l8 8" data-name="Line 326" stroke="#242022" strokeWidth={1.2} />
          <path d="M26.15 1.15l-8 8" data-name="Line 327" stroke="#242022" strokeWidth={1.2} />
        </g>
      </g>
    </svg>
  );
}

export default KamDeleteIcon;
